import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"
import ModelEntity from "../../../../../../model2/model-entity"
import {EntityType} from "../../../../../../gd/const/item"
import TaskTypeIcon from "../../../../../../gd-components/icons/task-icon/task-icon-ui5"
import Task from "../../../../../../model2/task/task"
import Project from "../../../../../../model2/project/project"
import ProjectIconUI5 from "../../../../../../gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../../gd-components/icons/@const"

// const debug = "FieldTimeReportEntity_ViewGroup"
const debug = false

export default function FieldTimeReportEntity_ViewGroup(props: FieldViewGroupProps) {

    const modelEntity = props.field.getViewValue(props.model) as ModelEntity

    debug && console.log(debug, 'render', modelEntity, props)

    const classes = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    let icon
    switch (modelEntity.itemType) {
        case EntityType.TASK:
            const task = modelEntity as Task
            icon = (
                <TaskTypeIcon
                    size        = {ItemIconSize.SIZE_13}
                    taskTypeId  = {task.taskTypeId}
                />
            )
            break

        case EntityType.PROJECT:
            const project = modelEntity as Project
            icon = (
                <ProjectIconUI5
                    project = {project}
                    size    = {ItemIconSize.SIZE_13}
                />
            )
            break

        case EntityType.MEETING:
            icon = <div className="ui5-ico-13 i5-meeting"/>
            break
    }

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    {icon}
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">
                {props.field.groupLabel(modelEntity, props.groupBy) || props.field.placeholder}
            </div>
        </div>
    )
}



